type CardProps = {
  cardRef?: React.MutableRefObject<HTMLDivElement | null>;
  children: React.ReactNode;
}

const Card = ({ cardRef, children } : CardProps) => {
  return (
    <div className="card" ref={cardRef}>
      {children}
    </div>
  );
}

export default Card